export default "/static/webpack/media/report-illustration.1e1c963a.svg";